/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type TradeDesignManagerModal_item$ref = any;
export type TradeDesignManagerModal_item = {
    readonly serviceId: string | null;
    readonly " $refType": TradeDesignManagerModal_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "TradeDesignManagerModal_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '2dcfb2291d5e1b86f198cc4e5908b7c4';
export default node;
